import styles from './message.module.scss';
import { MessageType } from './message.types';
import clsx from 'clsx';

interface MessageProps {
  text: string;
  isDisabled?: boolean;
  status?: MessageType;
  className?: string;
}

export function Message({ text, status, isDisabled, className }: MessageProps) {
  return (
    <p
      className={clsx(
        styles.message,
        status && styles[`message-${status}`],
        isDisabled && styles[`message-disabled`],
        className
      )}
    >
      {text}
    </p>
  );
}
